import { Skeleton } from '@app/components/various/Skeleton';
import { getCheckoutFields, getIsSeller } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { useSelector } from 'react-redux';

import { CheckoutAdditionalSkeleton } from '../CheckoutAdditional/CheckoutAdditionalSkeleton';
import { CheckoutPaymentsSkeleton } from '../CheckoutPayments';
import { CheckoutPoNumberSkeleton } from '../CheckoutPoNumber';
import { CheckoutOrdersSkeleton } from '../CheckoutProducts/CheckoutOrdersSplit/CheckoutOrdersSkeleton';
import { CheckoutShippingAddressSkeleton } from '../CheckoutShippingAddress/CheckoutShippingAddressSkeleton';
import { CheckoutShippingPreferencesSkeleton } from '../CheckoutShippingPreferences/CheckoutShippingPreferencesSkeleton';
import { CheckoutSubtotalSkeleton } from '../CheckoutSubtotal/CheckoutSubtotalSkeleton';
import { CheckoutSummarySkeleton } from '../CheckoutSummary/CheckoutSummarySkeleton';
import { CheckoutTermsAndConditionsSkeleton } from '../CheckoutTermsAndConditions/CheckoutTermsAndConditionsSkeleton';

export const CheckoutContentSkeleton = () => {
  const isSeller = useSelector(getIsSeller);
  const checkoutFields = useSelector(getCheckoutFields);

  return (
    <>
      <div className="mb-8 border-b border-neutral-90 pb-8">
        <CheckoutSummarySkeleton />
      </div>
      <CheckoutOrdersSkeleton />
      <div className="grid gap-x-20 lg:grid-cols-[1fr_20rem]">
        <div className="space-y-8 pt-8">
          {isDefined(checkoutFields.poNumber) && <CheckoutPoNumberSkeleton />}
          {isDefined(checkoutFields.shippingAddressId) && <CheckoutShippingAddressSkeleton />}
          <CheckoutShippingPreferencesSkeleton />
          <CheckoutAdditionalSkeleton />
          {!isSeller && <CheckoutTermsAndConditionsSkeleton />}
        </div>
        <div>
          <div className="z-topBar lg:sticky lg:top-[--headerHeight] lg:block lg:pt-8">
            <div className="mb-8">
              <CheckoutSubtotalSkeleton />
            </div>
            <CheckoutPaymentsSkeleton />
            <div className="hidden space-y-2 px-4 lg:block">
              <Skeleton type="button" size="large" />
              <Skeleton type="button" size="large" />
            </div>
          </div>
        </div>
      </div>
      <div className="contents px-4 pb-16 lg:hidden">
        <Skeleton type="button" size="large" />
        <div className="sticky bottom-0 left-0 right-0 bg-neutral-96 pt-2 lg:static">
          <Skeleton type="button" size="large" />
        </div>
      </div>
    </>
  );
};
